import * as MDT from 'mobile-device-detect';
import Game from '../Game';
import { IGameState } from '../State/Game/IGameState';
import { Immutable } from './Types';

export enum Platform {
    ANDROID = 'ANDROID',
    IOS = 'IOS',
    FACEBOOK = 'FACEBOOK',
    UNKNOWN = 'UNKNOWN',
    LOCAL = 'LOCAL',
}

enum ApplePlatform {
    Macintosh = 'Macintosh',
    MacIntel = 'MacIntel',
    MacPPC = 'MacPPC',
    Mac68K = 'Mac68K',
    Win32 = 'Win32',
    Win64 = 'Win64',
    Windows = 'Windows',
    WinCE = 'WinCE',
    iPhone = 'iPhone',
    iPad = 'iPad',
    iPod = 'iPod',
}

enum OS {
    MacOS,
    iOS,
    Windows,
    Android,
    Linux,
}

const macosPlatforms = [ApplePlatform.Macintosh, ApplePlatform.MacIntel, ApplePlatform.MacPPC, ApplePlatform.Mac68K];
const windowsPlatforms = [ApplePlatform.Win32, ApplePlatform.Win64, ApplePlatform.Windows, ApplePlatform.WinCE];
const iosPlatforms = [ApplePlatform.iPhone, ApplePlatform.iPad, ApplePlatform.iPod];
let canvas: any;

export function isShopSupported(state: Immutable<IGameState> = Game.store.getState()): boolean {
    return false;
}

export function getOS(): OS {
    let os: OS = null;

    if (window) {
        const platform: any = window.navigator.platform;
        if (macosPlatforms.indexOf(platform) !== -1) {
            os = OS.MacOS;
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = OS.iOS;
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = OS.Windows;
        } else if (/Android/.test(window.navigator.userAgent)) {
            os = OS.Android;
        } else if (!os && /Linux/.test(window.navigator.platform)) {
            os = OS.Linux;
        } else if (!os && /iPad/.test(window.navigator.userAgent)) {
            os = OS.iOS;
        }
    }

    // Using this to check IPad devices that are considered as Macbooks
    // when we use mobile-device-detect or our method to check it
    canvas = canvas || document.createElement('canvas');
    if (canvas) {
        var context = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        if (context) {
            var info = context.getExtension('WEBGL_debug_renderer_info');
            if (info) {
                var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL);

                switch (renderer) {
                    case 'Apple GPU':
                        // FIXME: This renderer is being detected on some macs as well so we need to find a better way to detect the ipad
                        // os = OS.iOS;
                        break;
                }
            }
        }
    }

    return os;
}

export function IsDesktop(): boolean {
    return [OS.MacOS, OS.Windows, OS.Linux].indexOf(getOS()) !== -1;
}

export function IsMobile(): boolean {
    return [OS.iOS, OS.Android].indexOf(getOS()) !== -1;
}

export function AdsSupported(): boolean {
    return true; //IsMobile();
}

export function isIOS(): boolean {
    return MDT.isIOS || getOS() === OS.iOS || isIPadOS();
}

export function isOSBelowVersion(osName: 'Android' | 'iOS', major: number): boolean {
    return MDT.osName === osName && parseFloat(MDT.osVersion) < major;
}

export function isNative(): boolean {
    return Game.config.platform === Platform.ANDROID || Game.config.platform === Platform.IOS;
}

export function isFacebook(): boolean {
    return Game.config.platform === Platform.FACEBOOK;
}

export function isIPadOS() {
    // Fix "navigator is not defined" when running tests.
    const navigator = (global as any).navigator;

    // SOLI-1887 - IpadOS is recognized as MacOS.
    // This workaround should work as long as there are no touch screen Macs.
    const { platform = '', maxTouchPoints = 0 } = navigator || {};
    return platform === 'MacIntel' && maxTouchPoints > 1;
}